<template>
    <div style="height:100%;">
        <div id="csContainer"></div>
        <div id="loadingOverlay"><h1>Loading........</h1></div>
    </div>
</template>

<script>
    import util from "../../components/util"

    export default {
        mounted() {
        var loa=document.getElementById('loadingOverlay');
        setTimeout(()=>{
           loa.style.display="none";
        },4000);
            this.init();
        },
        methods: {
            init() {
                let vw = util.getViewer("csContainer", {
                    animation: true,
                    timeline: true,
                    shadows: true,
                    // terrainShadows: Cesium.ShadowMode.ENABLED,
                    shouldAnimate: true,
                    // terrainProvider: Cesium.createWorldTerrain()
                });
                let shadowMap = vw.shadowMap;
                shadowMap.maximumDistance = 5000.0;
                // shadowMap.isPointLight = false;
                shadowMap.darkness = 0.3;
                shadowMap.size = 2048;
                shadowMap.softShadows = true;
                // shadowMap.numberOfCascades = 1;
                let clock = vw.clock;
                clock.multiplier = 20000;
                this._shadowAnalyse(vw);
            },
            _shadowAnalyse(viewer) {
                let longitude = 104.450625;
                let latitude = 31.939831;
                let height = 0;

                let entityCar = viewer.entities.add({
                    height: 0.0,
                    position: Cesium.Cartesian3.fromDegrees(longitude, latitude, height),
                    model: {
                        uri: '/demo/static/data/models/people.glb'
                    }
                });
                // viewer.trackedEntity = entityCar;
                viewer.zoomTo(entityCar);
                // viewer.clock.
            }
        }
    }
</script>

<style scoped>
    #csContainer {
        height: 100%;
    }
</style>
